import React, { useState, ReactNode } from 'react';
import './Accordion.css';

interface AccordionProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

export default function Accordion({ title, children, defaultOpen = false }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const toggleAccordion = () => setIsOpen((prev) => !prev);

  return (
    <div className="accordion">
      <button
        className="accordion-header"
        onClick={toggleAccordion}
        aria-expanded={isOpen}
      >
        <span className="accordion-title">{title}</span>
        <span className={`accordion-chevron ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      <div className={`accordion-body ${isOpen ? 'open' : ''}`}>
        {children}
      </div>
    </div>
  );
}
